export const SELECT_SHOP = 'SELECT_SHOP';
export const GET_SHOP_DETAILS = 'GET_SHOP_DETAILS';
export const GET_SHOP_DETAILS_SUCCEEDED = 'GET_SHOP_DETAILS_SUCCEEDED';
export const GET_SHOP_DETAILS_FAILED = 'GET_SHOP_DETAILS_FAILED';

export const SELECT_SHOP_TRIGGER = `${SELECT_SHOP}.TRIGGER`;
export const GET_SHOP_DETAILS_TRIGGER = `${GET_SHOP_DETAILS}.TRIGGER`;
